'use client'

import { Loader } from '@vinted/web-ui'

import { UiState } from '@marketplace-web/shared/ui-state-util'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

const ConversationLoader = () => {
  const { sendMessageUi } = useConversationContext()

  if (sendMessageUi.uiState !== UiState.Pending) return null

  return (
    <div className="conversation-loader__overlay">
      <div className="conversation-loader">
        <Loader styling="lifted" size="large" testId="conversation-loader" />
      </div>
    </div>
  )
}

export default ConversationLoader
